
















































































































































import { Inject } from '@cds/common';
import { I18nService } from '@cds/i18n';
import { Component, Ref, Vue } from 'vue-property-decorator';
import UEditor from '../../../components/rich-editor/rich-editor.vue';
import { DialogService } from '@/services/common/dialog.service';
import { ApiService } from '@/services/api-service';
import { ChannelService } from '@/services/channel-service';
import { ElTable } from 'element-ui/types/table';
import { assign } from 'lodash';
import { ElForm } from 'element-ui/types/form';
import { CloseStatus } from '@/services/common/models/dialog.interface';
import { DefaultFormData, getRules, DivisionOption } from '../config';
import { ResultStatus } from '@/services/common/http.service';
import { channellist, channelobj } from './index.config';
@Component({
  components: {
    UEditor
  }
})
export default class EditChannelDialog extends Vue {
  public rules: any = getRules(this.i18n);
  @Ref('form') private form!: ElForm;
  @Ref('multipleTable')
  private multipleTable!: ElTable;
  private data!: any;
  private formData: any = DefaultFormData;
  private channellist = channellist;
  // division
  private divisionOption: any[] = DivisionOption;
  get selectCount() {
    return this.formData.apiIds ? this.formData.apiIds.length : 0;
  }
  @Inject(DialogService) private dialog!: DialogService;
  @Inject(ApiService) private apiService!: ApiService;
  @Inject(ChannelService) private channelService!: ChannelService;
  // i18n
  @Inject(I18nService) private i18nSvc!: I18nService;
  private apiList: any[] = [];
  get i18n(): Dict<any> {
    return this.i18nSvc.i18nData;
  }
  public async created(): Promise<void> {
    this.formData = this.data;
    this.apiList = await this.apiService.getList();
    await this.getChannel(this.data.id);
  }

  public closeEditModal(): void {
    this.dialog.close();
  }

  public clearForm(): void {
    this.formData = {
      id: '',
      channelName: '',
      channelAgentId: '',
      channelSecret: '',
      agentId: '',
      secret: '',
      divisionCode: [],
      multipleSelection: [], // 表格多选
      apiIds: [],
      actionType: '',
      mfa:'',
      mpAppid:'',
      mpHome:'',
      divisionList: [] as any[]
    };
    this.form.resetFields();
  }

  public onSave(): void {
    this.form.validate(this.formValidHandler.bind(this));
  }

  private handlethirdparty(val: string) {
    if (val === 'none') {
      this.formData.thirdPartyTitle = '';
      this.formData.thirdPartyDescription = '';
    } else {
      this.formData.thirdPartyTitle = channelobj[val].title;
      this.formData.thirdPartyDescription = channelobj[val].content;
    }
  }

  public async onCreateSecret(): Promise<void> {
    const h = this.$createElement;
    await this.$msgbox({
      title: this.i18n.channel_mgmt.regenerate,
      message: h('p', undefined, [
        h('span', undefined, this.i18n.channel_mgmt.recreate_info)
      ]),
      showCancelButton: true,
      cancelButtonText: this.i18n.channel_mgmt.cancel,
      confirmButtonText: this.i18n.channel_mgmt.confirm,
      confirmButtonClass: 'btn-color-blue',
      beforeClose: (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = this.i18n.channel_mgmt.doing;
          this.doCreateSecret();
          setTimeout(() => {
            done();
            setTimeout(() => {
              instance.confirmButtonLoading = false;
            }, 300);
          }, 3000);
        } else {
          done();
        }
      }
    });
  }
  // 表格全选功能
  public handleSelectionChange(val: any): void {
    // console.log('______________', val);
    const arrayIds: any = [];
    // let arrayNames: any[] = [];
    val.forEach((item: any, index: number) => {
      arrayIds[index] = item.id;
    });
    this.formData.apiIds = arrayIds;
    this.formData.multipleSelection = val;
  }
  public change(): void {
    this.$forceUpdate();
  }

  private async getChannel(id: any): Promise<void> {
    const result = await this.channelService.getChannel(id);
    if (result.apiIds && result.apiIds.length) {
      result.apiIds.forEach((item: any, index: any) => {
        this.apiList.forEach((item2: any, index2: any) => {
          if (item === item2.id) {
            // 拼装行元素
            let row: any = this.apiList[index2];
            // 改变 table中 已选中行元素
            this.multipleTable.toggleRowSelection(row, true);
          }
        });
      });
    } else if (this.formData.apiIds) {
      this.formData.apiIds.length = 0;
    }

    this.formData = assign({}, result);

    this.$set(this.formData, 'divisionCode', '');
    this.formData.divisionCode = result.divisionCodeList.map(Number);
  }

  private async formValidHandler(valid: any): Promise<void | boolean> {
    if (valid) {
      // 获取divisionName
      if (this.formData.divisionCode) {
        let divisionCodeArr: any[] = [];
        divisionCodeArr = this.formData.divisionCode;
        let divisionTmp: any[] = [];
        divisionCodeArr.forEach((item: any, index: any) => {
          let division: any = {};
          let obj: any = {};
          obj = this.divisionOption.find((item1) => {
            // 这里的Data就是上面遍历的数据源
            return item1.value === item; // 筛选出匹配数据
          });
          if (obj) {
            division.divisionCode = obj.value;
            division.divisionName = obj.label;
            // divisionNameArr[index] = obj.label;
            divisionTmp[index] = division;
          }
        });
        this.formData.divisionList = divisionTmp;
      }
      const res = assign({}, this.formData);
      delete res.divisionCode;
      await this.channelService.edit(res);
      this.dialog.close(CloseStatus.confirm);
      this.$message({
        message: this.i18n.channel_mgmt.save_success,
        type: ResultStatus.SUCCESS
      });
    } else {
      this.$message.error('请正确填写表单');
      // console.log('error submit!!');
      return false;
    }
  }

  private async doCreateSecret(): Promise<void> {
    const result = await this.channelService.getSecret();
    this.formData.secret = result;
  }
}
